import React from "react";
import styled from "styled-components";

// import Avatar from "../Avatar/Avatar";
// import { SearchIcon } from "../../../SVGS";

const DropDownRendererStyles = styled.div`
  width: 100%;
  max-height: 352px;
  overflow: hidden;

  .searchContainer {
    position: relative;
    width: 100%;
    height: 38px;
    display: flex;
    align-items: center;

    .iconContainer {
      position: absolute;
      z-index: 2;
      left: 12px;
    }

    .searchInput {
      position: relative;
      width: 100%;
      border: none;
      background: ${({ theme }) => theme.colors.semantic.container.white};
      border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
      box-sizing: border-box;
      border-radius: ${({ theme }) => theme.radius[4]};
      padding: ${({ theme }) => theme.spacing[8]};
      height: 100%;
      font-style: normal;
      font-weight: ${({ theme }) => theme.typography.body.b2.weight};
      font-size: ${({ theme }) => theme.typography.body.b2.size};
      line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
      color: ${({ theme }) => theme.colors.semantic.text.strong};
      outline: none;
    }

    .searchInput::placeholder {
      opacity: 0.5;
    }
  }

  .line {
    margin-top: 8px;
    border: 1px solid ${({ theme }) => theme.colors.semantic.separator};
  }

  .optionsContainer {
    max-height: 240px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
    display: flex;
    flex-direction: column;
    gap: 4px;

    .option {
      padding: 8px 12px;
      display: flex;
      align-items: center;
      cursor: pointer;
      border-radius: ${({ theme }) => theme.radius[4]};
      transition: background 0.15s ease;

      &:hover {
        background: ${({ theme }) => theme.colors.accent[50]};
      }

      &.selected .value {
        color: ${({ theme }) => theme.colors.semantic.text.strong};
      }

      .value {
        font-style: normal;
        font-weight: ${({ theme }) => theme.typography.body.b2.weight};
        font-size: ${({ theme }) => theme.typography.body.b2.size};
        line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
        color: ${({ theme }) => theme.colors.semantic.text.weak};
      }
    }
  }
`;

const DropDownRenderer = ({ props, state, methods }) => {
  const regexp = new RegExp(state.search, "i");
  const filteredOptions = props.options.filter(item =>
    regexp.test(item[props.searchBy] || item[props.labelKey] || item.label1)
  );
  return (
    <DropDownRendererStyles>
      {props.searchable && (
        <div className="searchContainer">
          {/* <div className="iconContainer">
            <SearchIcon />
          </div> */}
          <input
            value={state.search}
            onChange={methods.setSearch}
            type="text"
            className="searchInput"
            placeholder="Search"
          />
        </div>
      )}
      {filteredOptions.length > 0 && props.searchable && (
        <hr className="line" />
      )}
      <div className="optionsContainer">
        {filteredOptions.map((option, i) => {
          const isSelected = methods.isSelected(option);
          return (
          <div
            className={`option${isSelected ? " selected" : ""}`}
            key={option[props.valueKey]}
            onClick={() => methods.addItem(option)}
          >
            {/* {props.withImage && (
                <Avatar
                  size={props.size}
                  src={props.src}
                  isCircle={props.isCircle}
                  alt="option"
                  style={{ marginRight: props.isCircle ? 20 : 12 }}
                />
              )} */}
            <div>
              <p className={`value`}>{option[props.labelKey]}</p>
              <p className={`value`} style={{ opacity: 0.4 }}>
                {option.label1 && option.label1}
              </p>
            </div>
          </div>
          );
        })}
      </div>
    </DropDownRendererStyles>
  );
};

export default DropDownRenderer;
